import { Box, Button, Typography } from "@mui/material";
import Layout from "../templates/Layout";
import { useAppNavigate } from "../../routes/useAppNavigate";

const NotFoundPage = () => {
  const { authenticatedNavigate } = useAppNavigate();
  return (
    <Layout title="404 Not Found" disableBack>
      <Box textAlign={"center"}>
        <Typography mb={10} variant="h3">
          404
        </Typography>
        <Typography mb={10}>
          指定されたページは存在しないか、移動された可能性があります。
        </Typography>
        <Button
          sx={{ maxWidth: "sm" }}
          variant="contained"
          fullWidth
          onClick={() => authenticatedNavigate.root()}
        >
          ホームに戻る
        </Button>
      </Box>
    </Layout>
  );
};

export default NotFoundPage;
